import React from "react";
import moment from "moment";
import "moment-duration-format";
const TimeBasedRotationStrategySummary = ({ config }) => {
  const humanizedPeriod = () => {
    const duration = moment.duration(config.rotation_period);
    return `${duration.format()}, ${duration.humanize()}`;
  };
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("dl", null, /* @__PURE__ */ React.createElement("dt", null, "Index rotation strategy:"), /* @__PURE__ */ React.createElement("dd", null, "Index Time"), /* @__PURE__ */ React.createElement("dt", null, "Rotation period:"), /* @__PURE__ */ React.createElement("dd", null, config.rotation_period, " (", humanizedPeriod(), ")"), /* @__PURE__ */ React.createElement("dt", null, "Rotate empty index set:"), /* @__PURE__ */ React.createElement("dd", null, config.rotate_empty_index_set ? "Yes" : "No")));
};
export default TimeBasedRotationStrategySummary;
